import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FooterService } from '../../components/footer/footer.service';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { CommonService } from '../../shared/common.service';
import { StorageKey, StorageService } from '../../shared/storage.service';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  profileImageUrl: string = 'assets/image/userphoto.png'; 
  profileLetter: string;
  @ViewChild('fileInput') fileInput: ElementRef;
  userProfile: any;  
  errorMessage: string = '';

  constructor(private footerService: FooterService,
    public userLayoutService: UserLayoutService,
    public commonService: CommonService,
    public storageService: StorageService,
    private router: Router,
  ) { }

  ngOnInit(): void {
    let userId = localStorage.getItem("_id");
    if (userId === null){
      this.router.navigate(['']);
    }
    this.footerService.hideFooter();
    this.loadProfileImage();
    this.fetchUserProfile();
  }

  fetchUserProfile(): void {
    const userId = this.storageService.getValue(StorageKey.id); 

      if (userId) {
          const profileData = { userId: userId };

          this.userLayoutService.UserProfile(profileData).subscribe((response: any) => {
              if (response.code === 1) {
                  this.userProfile = response.data; 
                  // console.log("ProfileData" , this.userProfile)
                  this.profileImageUrl = response.data.imagePath ;
                  localStorage.setItem('profileImage', this.profileImageUrl);
                  // console.log("ProfileData", this.userProfile);

                  this.profileImageUrl = response.data.imagePath || this.profileImageUrl;

                  if (this.userProfile.firstName) {
                    this.profileLetter = this.userProfile.firstName.charAt(0).toUpperCase();
                  }
                  // console.log(this.profileLetter , this.userProfile.firstName)
        
                  localStorage.setItem('profileImage', this.profileImageUrl);

              } else {
                  this.errorMessage = response.message;
                  this.commonService.notifier.notify('error', response.message);
              }
          },
          (error) => {
              // this.errorMessage = 'Failed to fetch profile data';
              // console.log('Profile API Error:', error);
              // this.commonService.notifier.notify('error', this.errorMessage);
          });
      } else {
          // this.errorMessage = 'No user ID found. Please log in.';
          // this.commonService.notifier.notify('error', this.errorMessage);
      }
  }
  
  loadProfileImage(): void {
    const storedImageUrl = localStorage.getItem('profileImage');
    if (storedImageUrl) {
      this.profileImageUrl = storedImageUrl; 
    }
  }

  onChangePhoto(): void {
    this.fileInput.nativeElement.click();
  }

  onFileSelected(event: Event): void {
    const file = (event.target as HTMLInputElement).files?.[0];
    if (file) {
      this.uploadProfileImage(file);
    }
  }

  uploadProfileImage(file: File): void {
    const formData = new FormData();
    formData.append('image', file);

    this.userLayoutService.UpdateProfileImage(formData).subscribe(
      (response: any) => {
        if (response.code === 1) {
          this.profileImageUrl = response.data.image;
          const loginUserData = JSON.parse(localStorage.getItem('LoginUserData') || '{}');
          loginUserData.profileImage = response.data.image;
          this.commonService.updateLoginUserData(loginUserData);
          this.commonService.notifier.notify('success', 'Profile image updated successfully');
        } else {
          // this.commonService.notifier.notify('error', response.message);
        }
      },
      (error) => {
        // console.log('Update Family Member API Error:', error);
        // this.commonService.notifier.notify('error', 'Failed to update family member');
      }
    );
  }

  logout(): void {
    Swal.fire({
      title: 'Are you sure you want to logout?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      customClass: {
        popup: 'custom-swal-font'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.clear();
        this.commonService.notifier.notify('success', 'User logged out successfully');
        window.location.reload();
      }
    });
  }

  deleteAccount() {
    Swal.fire({
      title: 'Are you sure you want to delete account?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      customClass: {
        popup: 'custom-swal-font'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        let userId = localStorage.getItem("_id");
        this.userLayoutService.deleteAccount(userId).subscribe(
            (Response: any) => {
                if (Response.code === 1) {
                  localStorage.clear();
                  this.commonService.notifier.notify('success', 'Account deleted successfully.');
                  window.location.reload();
                } else {
                    this.commonService.notifier.notify('error', Response.message);
                }
            },
            (error) => {
                this.commonService.notifier.notify('error', error);
            }
        );
      }
    });
  }
  
  onImageError(event: any) {
    event.target.src = 'assets/image/userphoto.png';
  }

  goBack(): void {
    this.router.navigate(['home']);
  }
}
